import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const { sendAuthenticatedRequest } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await sendAuthenticatedRequest('/users/forgot', 'POST', {
        email,
      });

      if (response.success) {
        toast.success(
          'Password reset instructions have been sent to your email.'
        );
        navigate('/login');
      } else {
        toast.error(response.error || 'Failed to send reset instructions.');
      }
    } catch (error) {
      toast.error('Failed to process password reset request.');
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="bg-foreground shadow-lg rounded-lg p-8 w-full max-w-md">
        <h2 className="text-2xl font-semibold text-primary text-center mb-6">
          Password Reset
        </h2>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label
              htmlFor="email"
              className="block text-secondary font-medium mb-1"
            >
              Email
            </label>
            <input
              type="email"
              id="email"
              className="w-full px-4 py-2 border border-secondary rounded focus:outline-none focus:ring-2 focus:ring-accent"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <button
            type="submit"
            className="w-full bg-primary text-foreground py-2 rounded hover:bg-secondary focus:outline-none focus:ring-2 focus:ring-accent"
          >
            Reset Password
          </button>
        </form>
        <p className="mt-6 text-center text-secondary">
          Remember your password?{' '}
          <a href="/login" className="text-link hover:underline">
            Log in
          </a>
        </p>
        <p className="mt-2 text-center text-secondary">
          Don't have an account?{' '}
          <a href="/register" className="text-link hover:underline">
            Sign up
          </a>
        </p>
      </div>
    </div>
  );
}

export default ForgotPassword;
